import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { ATCCodeModel } from "../../../models/atcCode";
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';
import { InputTextarea } from 'primereact/inputtextarea';
import { AtcCodeContentModel } from '../../../models/atcCode/atcCodeContentModel';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentATCCode: ATCCodeModel;
}

interface IState {
	atcCode: ATCCodeModel,
	validationMessage: string,
	selectedLangId: number
}

class AtcCodeAddEditDialog extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {
			atcCode: props.currentATCCode,
			validationMessage: '',
			selectedLangId: Lang.bg
		};
	}

	handleChange = (key, value) => {
		const atcCode: ATCCodeModel = { ...this.state.atcCode };
		atcCode[key] = value;
		this.setState({ atcCode: { ...atcCode } });
	};

	handleChangeContent = (key, value) => {
		const atcCode: ATCCodeModel = { ...this.state.atcCode };
		let atcCodeContent = atcCode.atcCodeContent.find(r => r.langId == this.state.selectedLangId);
		if (atcCodeContent) {
			atcCodeContent[key] = value;
		}
		this.setState({ atcCode: { ...atcCode } });
	};

	isValidAddEditForm() {
		let message = '';

		this.setState({
			validationMessage: ''
		});

		if ((!this.state.atcCode.atcCode || this.state.atcCode.atcCode.trim() == '')) {
			message += "Please enter 'ATC Code'.<br />";
		}

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = event => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const atcCode = this.state.atcCode;

		this.props.saveClick(atcCode);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	onLangChange = (lang) => {
		this.setState({ selectedLangId: lang });
	}

	getInputField = () => {
		for (let content of this.state.atcCode.atcCodeContent) {
			if (content.langId == this.state.selectedLangId) {
				return <InputText
					name="aTCCodeName"
					onChange={(e) => this.handleContentChange(e.target['value'])}
					value={content.atcCodeName ? content.atcCodeName : ""}
				/>
			}
		}
	}
	getValueContent = (key) => {
		let anatomicalSystemContent = this.state.atcCode.atcCodeContent.find(r => r.langId == this.state.selectedLangId)
		if (anatomicalSystemContent) {
			return anatomicalSystemContent[key];
		}
		return '';
	}

	handleContentChange = (value) => {
		const atcCode: ATCCodeModel = { ...this.state.atcCode };
		let atcContent: Array<AtcCodeContentModel> = [...atcCode.atcCodeContent];
		let currentAtcContent = atcContent.find(r => r.langId == this.state.selectedLangId);
		if (currentAtcContent) {
			currentAtcContent.atcCodeName = value;
			this.setState({ atcCode: { ...atcCode } });
		}
	}

	public render() {

		const { atcCode, selectedLangId } = this.state;

		return (

			<Dialog header="ATC Code Form" responsive={true} width="70%"
				modal={true}
				visible={this.props.isVisible}
				onHide={this.handleCanselButton}
				footer={
					<div>
						<Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
						<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
					</div>}
			>
				<div style={{ minHeight: '400px', maxHeight: '650px' }}>

					{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
					<div className="p-grid p-fluid">
						<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						<div className="p-col-12 p-md-12">
							<label>ATC code:</label>
							<InputText
								name="atcCode"
								onChange={(e) => this.handleChange('atcCode', e.target['value'])}
								value={atcCode && atcCode.atcCode ? atcCode.atcCode : ""}
							/>
						</div>
						<div className="p-col-12 p-md-12">
							<label>Name:</label>
							<InputText
								name="atcCodeName"
								onChange={(e) => this.handleChangeContent('atcCodeName', e.target['value'])}
								value={this.getValueContent('atcCodeName')}
							/>
						</div>
					</div>

				</div>
			</Dialog >
		)
	}
}

export default AtcCodeAddEditDialog;